const initialState = 'fastPaymentMenu'

const chooseParkingFormReducer = (
  state = initialState,
  action: any
) => {
  const {type, payload} = action
  switch (type) {
    case 'SET_CHOOSE_PARKING_FORM':
      return payload
    default:
      return state
  }
}

export {chooseParkingFormReducer}